jQuery(document).ready(function($){
    const floating_labels = () => {
        if ( $('.gform-body').length === 0 ) {
            return;
        }

        $('.gfield_label:not(.screen-reader-text)').each(function(){
            if ( $(this).css('position') !== 'absolute' ) {
                return;
            }

            if ( $(this).closest('.gfield').find('input, select, textarea').val() !== '' ) {
                $(this).closest('.gfield').addClass('should-float-label');
            }

            $(this).closest('.gfield').addClass('has-floating-label');
        });
    }

    jQuery(document).on('gform_post_render', function(event, form_id, current_page){
        floating_labels();

        $('.gform_footer').each(function(){
            if ( $(this).find('.gform_submit_wrapper').length === 0 ) {
                $(this).find('.gform_button').wrap('<div class="gform_submit_wrapper"></div>');
            }
        });
    });

    jQuery(document).on('blur change', '.gfield.has-floating-label', function(event, form_id, current_page){
        if ( $(this).find('.ginput_container > *').val() !== '' ) {
            $(this).addClass('should-float-label');
        }
        else {
            $(this).removeClass('should-float-label');
        }
    });

    jQuery(document).on('click focus', '.gfield.has-floating-label', function(event, form_id, current_page){
        if ( $(this).find('.ginput_container > *').is(':focus') ) {
            $(this).addClass('should-float-label');
        }
        else {
            $(this).removeClass('should-float-label');
        }
    });
});